import _extends from "@babel/runtime/helpers/extends";
import { groupErrorsByTarget } from '@wix/form-validator';
import React, { useCallback, useMemo } from 'react';
import { useExternalData } from '../../contexts/external-data-context';
import { useFormFields } from '../../contexts/form-fields-context';
import { useForm } from '../../../../contexts/form-context';
import { FieldPropsContext } from '../../../../contexts/field-props-context';
import { FIELD_PROPS_MAPPERS } from '../../../../mappers/public-props-map';
export const NestedFormField = _ref => {
  let {
    field,
    errors,
    values,
    onFieldChange,
    FieldLayout
  } = _ref;
  const componentsById = useFormFields();
  const externalData = useExternalData();
  const form = useForm();
  const fieldValue = values[field.target];
  const errorsByTarget = useMemo(() => groupErrorsByTarget(errors), [errors]);
  const fieldErrors = errorsByTarget == null ? void 0 : errorsByTarget[field.target];
  const fieldError = fieldErrors == null ? void 0 : fieldErrors[0];
  const {
    requiredIndicator,
    requiredIndicatorPlacement
  } = form.requiredIndicatorProperties || {};
  const propsMapper = FIELD_PROPS_MAPPERS[field.fieldType];
  const handleChange = useCallback(value => {
    if (!value) {
      value = null;
    }
    onFieldChange == null || onFieldChange(field.target, value);
  }, [onFieldChange, field]);
  const FieldComponent = componentsById[field.fieldType];
  if (!FieldComponent) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldPropsContext.Provider, {
    value: {
      ...propsMapper({
        ...field.properties,
        id: field.id,
        target: field.target,
        path: field.path,
        error: fieldError,
        errors: fieldErrors,
        value: fieldValue,
        externalData,
        fieldType: field.fieldType,
        requiredIndicatorType: requiredIndicator,
        requiredIndicatorPlacement
      }),
      onChange: handleChange
    }
  }, /*#__PURE__*/React.createElement(FieldComponent, _extends({}, field.properties, {
    onChange: handleChange,
    error: fieldError,
    errors: fieldErrors,
    value: fieldValue,
    id: field.id,
    target: field.target,
    path: field.path,
    externalData: externalData,
    fieldType: field.fieldType,
    FieldLayout: FieldLayout,
    requiredIndicatorType: requiredIndicator,
    requiredIndicatorPlacement: requiredIndicatorPlacement
  })));
};
//# sourceMappingURL=nested-form-field.js.map